import React from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useStorage } from 'Hooks/'
import PropTypes from 'prop-types'

import {
  Panel,
  Button,
  SpacingVertical,
  SPACING_16,
  MessageBox,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'

import { abTestState } from 'Pages/AbTestManage/recoil/state/abTest'
import { abTestManageIsValidState } from 'Pages/AbTestManage/recoil/state/page'
import {
  initAbTestManageCallback,
  rePlanAbTestWinnerCallback,
  winnerPlanCallback
} from 'Pages/AbTestManage/recoil/callbacks/callbacks'

import { STORE_KEY_LIST } from 'Constants'

const BoxDate = ({ scheduleDate, scheduleTimeZoneCode }) => {
  const intl = useIntl()
  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values
  const {
    showReplanBtn,
    showPlanBtn,
    testEnded,
    testRunning,
    idWinnerMessageManual,
    showInfoMessageScheduledBoxConfig
  } = useRecoilValue(abTestState)
  const abTestManageIsValid = useRecoilValue(abTestManageIsValidState)
  const rePlanAbTestWinner = useRecoilCallback(rePlanAbTestWinnerCallback, [])
  const winnerPlan = useRecoilCallback(winnerPlanCallback, [])
  const init = useRecoilCallback(initAbTestManageCallback, [])
  const { id } = useParams()

  const handleRePlan = () => {
    rePlanAbTestWinner().then(resp => {
      init(id)
    })
  }

  const handleWinnerPlan = () => {
    winnerPlan().then(resp => {
      init(id)
    })
  }

  return (
    <>
      <Panel collapsible={false}>
        <ContentScheduled
          scheduleDate={scheduleDate}
          scheduleTimeZoneCode={scheduleTimeZoneCode || listTimeZoneCode}
          sendTypeScheduledTextVisible={false}
          timeZoneDisabled={testEnded}
          mode={'MODE_SCHEDULED'}
        />
        {showInfoMessageScheduledBoxConfig && (
          <>
            <SpacingVertical variant={SPACING_16} />
            <MessageBox>
              {intl.formatMessage({
                id: 'Load.AbTest.AbTestMenageTestRunningInfo'
              })}
            </MessageBox>
          </>
        )}
        {showReplanBtn && (
          <Flex height='64px' alignItems='flex-end' justifyContent='flex-end'>
            <Button
              kind='secondary'
              data-mu-test='abTestManage-WinnerRePlan'
              onClick={handleRePlan}
              disabled={!abTestManageIsValid || testRunning}
            >
              {intl.formatMessage({ id: 'Load.AbTest.WinnerRePlan' })}
            </Button>
          </Flex>
        )}
        {showPlanBtn && (
          <Flex height='64px' alignItems='flex-end' justifyContent='flex-end'>
            <FlexItem>
              <Button
                kind='primary'
                data-mu-test='abTestManage-PianificaVincente'
                onClick={handleWinnerPlan}
                disabled={!abTestManageIsValid || !idWinnerMessageManual}
              >
                {intl.formatMessage({ id: 'Load.AbTest.PianificaVincente' })}
              </Button>
            </FlexItem>
          </Flex>
        )}
      </Panel>
    </>
  )
}

BoxDate.propTypes = {
  scheduleDate: PropTypes.any,
  scheduleTimeZoneCode: PropTypes.any
}

export default BoxDate
